import { Flex, Radio } from "antd"
import { LineItemGroupingOption } from "../../../domain/invoicing/settings/invoicingSettings"
import SettingsTitledCard from "../SettingsTitledCard"
import RadioButton from "../../common/RadioButton"
import VSpace from "../../common/VSpace"

type Props = {
  jobTypeName: string
  option: LineItemGroupingOption
  onChange: (option: LineItemGroupingOption) => void
}

const JobTypeLineItemGroupingCard = ({ jobTypeName, option, onChange }: Props) => {
  return <SettingsTitledCard
    title={jobTypeName}
    description="Set the default line item grouping for each job type."
  >
    <Radio.Group value={option} onChange={x => onChange(x.target.value)} style={{ width: '100%' }}>
      <Flex gap={8} style={{ width: '100%' }}>
        <VSpace>
          <RadioButton value="perGroup" checked={option === 'perGroup'} onBorderClick={() => onChange('perGroup')}>Line Item Per Group</RadioButton>
          <RadioButton value="perWorkarea" checked={option === 'perWorkarea'} onBorderClick={() => onChange('perWorkarea')}>Line Item Per Work Area</RadioButton>
        </VSpace>
        <VSpace>
          <RadioButton value="perWorkareaAndVisit" checked={option === 'perWorkareaAndVisit'} onBorderClick={() => onChange('perWorkareaAndVisit')}>Line Item Per Work Area and Visit</RadioButton>
          <RadioButton value="perWorkareaItem" checked={option === 'perWorkareaItem'} onBorderClick={() => onChange('perWorkareaItem')}>Line Item Per Work Area Item</RadioButton>
        </VSpace>
      </Flex>
    </Radio.Group>
  </SettingsTitledCard>
}

export default JobTypeLineItemGroupingCard